import {ScheduledRunEffects} from './scheduled-run.effects'
import {WeeklyScheduleEffects} from './weekly-schedule.effects'
import {RunSegmentEffects} from './run-segment.effects'
import {ScheduleUiSettingsEffects} from './schedule-ui-settings.effects'

export const scheduleEffects = [
    ScheduledRunEffects,
    WeeklyScheduleEffects,
    RunSegmentEffects,
    ScheduleUiSettingsEffects
]